import http from 'common-module/src/util/http';

/**
 * 项目编号获取问题类型列表选择器
 * @returns {Promise<*>}
 */
export const getIssueTypeList = async (projectId) => {
  return http.post('/issue-type/list-selector/project-id', { projectId });
};

/**
 * 获取状态列表
 * @returns {Promise<*>}
 */
export const getIssueSelectOptions = async (issueTypeId, projectId) => {
  return http.post('/issue/select-options', { issueTypeId, projectId });
};

/**
 * 获取状态列表
 * @returns {Promise<*>}
 */
export const getIssueQickAdd = async (data) => {
  return http.post('/issue/batch-quick-add', data);
};
/**
 * 获取状态列表
 * @returns {Promise<*>}
 */
export const getProjectsFeatureSwitches = async (projectIds) => {
  return http.post('project/switches/batch-query', projectIds);
};

/**
 * 获取指派人推荐列表
 * @param data
 * @returns {Promise<*>}
 */
export const getAssigneeRecommendList = async data => {
  return http.post('/issue/assignee-recommend', data, { showError: false });
};

/**
 * 事项属性值批量更新
 * @returns {Promise<*>}
 */
export const getMultilIssueUpdate = async (data) => {
  return http.post('issue/batch-field-update', data);
};
